import { Alert } from "@mui/material";
import { LicensePicker } from "Components/Licenses/LicensePicker/LicensePicker";
import { StepBox } from "Components/Onboarding/shared/StepBox";
import { FullHeightForm } from "Components/Shared/FormStyles";
import { ValuesBox } from "Components/Shared/ValuesBox/ValuesBox";
import type { PartyLicenseDto } from "Infrastructure/Api/Api";
import { Resources, useResource } from "Translations/Resources";

const COMPONENT_RESOURCES =
  Resources.Onboarding.BusinessOnboarding.Steps.LicenseSelection;

type Props = {
  license: PartyLicenseDto;
  onContinue: () => void;
};

// A paid (or processing) licence must not be reordered — show it read-only and move on.
export const OwnedLicenseContent = ({ license, onContinue }: Props) => {
  const { t } = useResource();

  return (
    <FullHeightForm>
      <StepBox
        submitButtonLabel={t(Resources.Common.Continue)}
        onSubmitClick={onContinue}
        submitButtonDescription={
          <Alert severity="info">{t(COMPONENT_RESOURCES.AlreadyOwned)}</Alert>
        }
      >
        <ValuesBox title={t(Resources.Common.License)}>
          <LicensePicker
            isDisabled
            onSelect={() => undefined}
            defaultValue={license.code}
            currentValue={license.code}
            region={license.region}
            hasEdgeBleed
          />
        </ValuesBox>
      </StepBox>
    </FullHeightForm>
  );
};
